"use client";

import React from "react";
import SectionHeading from "./section-heading";
import { useSectionInView } from "@/lib/hooks";
import TimelineElement from "./timeline-element";
import { useI18nContext } from "@/context/i18n-context";
import en from "@/locale/en";

type ExperienceItem = (typeof en.experience.data)[number];

export default function Experience() {
  const { t } = useI18nContext();
  const links: { name: string; hash: string }[] = t("links");
  const { ref } = useSectionInView(links[4]?.name ?? "Experience", 0.5);

  const items: ExperienceItem[] = t("experience.data");

  return (
    <section
      id="experience"
      ref={ref}
      className="w-full max-w-[52rem] scroll-mt-28 mb-24 sm:mb-32"
    >
      <SectionHeading>{t("experience.title")}</SectionHeading>

      {/* Custom timeline — no third-party library */}
      <div className="relative">
        {items.map((item, index) => (
          <div
            key={index}
            className={index === items.length - 1 ? "[&_.timeline-spine]:hidden" : ""}
          >
            <TimelineElement item={item} index={index} />
          </div>
        ))}
      </div>
    </section>
  );
}
